// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function PriceFromJSON(json) {
    return {
        'date': new Date(json['date']),
        'amount': json['amount'],
    };
}
export function PriceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'date': value.date.toISOString().substr(0, 10),
        'amount': value.amount,
    };
}
